// ACTIONS

import { UpdateClusterHoveredPayload, UpdateClusterSelectedPayloadAction } from 'tabs/topQuestions/types/InternalTypes'
import {
  UPDATE_CLUSTER_HOVERED,
  UPDATE_DISPLAYED_CLUSTER,
  UPDATE_TOP_QUESTIONS_COLOR_MAP,
  UpdateClusterDisplayedStatus,
  UpdateClusterHovered,
  UpdateTopQuestionsColorMap,
} from 'tabs/topQuestions/lib/top_questions/topQuestionsConstnats'


export const updateClusterDisplayed = (payload: UpdateClusterSelectedPayloadAction): UpdateClusterDisplayedStatus => ({
  type: UPDATE_DISPLAYED_CLUSTER,
  payload,
})

export const updateClusterHovered = (payload: UpdateClusterHoveredPayload): UpdateClusterHovered => ({
  type: UPDATE_CLUSTER_HOVERED,
  payload,
})

export const updateTopQuestionsColorMap = (payload: Record<string, number[]>): UpdateTopQuestionsColorMap => ({
  type: UPDATE_TOP_QUESTIONS_COLOR_MAP,
  payload,
})
